import index_api from "./index_api";
import login_api from "./login_api";
import website_api from "./website_api";
import financial_api from "./financial_api";
import sl_api from "./sl_api";
import chat_api from "./chat_api";
import shop_api from "./shop_api";
import workOrder_api from "./workOrder_api";
import imageCenter_api from "./imageCenter";

export default {
  index_api,
  login_api,
  website_api,
  financial_api,
  sl_api,
  chat_api,
  shop_api,
  workOrder_api,
  imageCenter_api
};


// WEBPACK FOOTER //
// ./src/api/public/index.js